export const DEAL_AUTOMATION_RULE_EVENTS = [
  { key: 'deal_created', value: 'NEGOCIO_CRIADO', label: 'Negocio criado' },
  { key: 'deal_updated', value: 'NEGOCIO_ATUALIZADO', label: 'Negocio atualizado' },
];

export const isDealAutomationEvent = eventName =>
  DEAL_AUTOMATION_RULE_EVENTS.some(event => event.key === eventName);

export const emptyDealCondition = () => ({
  attribute_key: 'status',
  filter_operator: 'equal_to',
  query_operator: 'AND',
  selectedPipelineId: null,
  selectedStageId: null,
  selectedStatus: 'open',
  selectedPriority: '',
  selectedAssigneeId: null,
  selectedLossReasonId: null,
  inputValue: '',
  dateTimeValue: '',
});

export const emptyDealAction = () => ({
  action_name: 'change_stage',
  selectedPipelineId: null,
  selectedStageId: null,
  selectedAssigneeId: null,
  selectedStatus: 'open',
  selectedPriority: '',
  selectedLossReasonId: null,
  lossJustification: '',
  note: '',
  webhookUrl: '',
  activityTypeId: null,
  activityTitle: '',
  activityDescription: '',
  activityDueAt: '',
  actionParamsInput: '',
});

